export interface IUserArtsQueryArgs {
  limit?: number;
  art_groups?: number[];
  library_request_verdicts?: string[];
  read_status?: string[];
  after?: string;
}

export interface IUserArtsWithSubscriptionQueryArgs extends IUserArtsQueryArgs {
  only_in_subscription_id?: number;
  id_list?: string;
}

// TODO выпилить после перехода на union
export enum EArtActionSource {
  archived = "archive",
  cart = "cart",
  campaigns = "campaigns",
  cloud = "cloud",
  library = "library",
  wishlist = "favorites",
  purchased = "my",
  inProgress = "read_listen",
  finished = "finished",
  folders = "user_lists",
}

export interface IActionArtWithSource<
  T extends TArtActionSource = TArtActionSource,
> {
  artId: number;
  /* при передаче данного параметра определяется какой эндпоинт будет "оптимисточно" обновлен */
  source?: EArtActionSource | T;
}

/* Значение source определяет на какой странице или в каком контексте вызван action
 * это нужно для точечного "оптимистичного" обновления кэша RTK Query.
 * Если "оптимистично" обновлять все что может потребовать "оптимистичного" обновления без ограничений в виде признака
 * source это может вызвать "лаги" на клиенте, т.к. будет выполняться слишком много кода, это было проверено
 * в "Моих книгах" на действиях с артом */
export type TArtActionSource =
  | "archive"
  | "cart"
  | "campaigns"
  | "cloud"
  | "library"
  | "favorites"
  | "my"
  | "read_listen"
  | "finished"
  | "user_lists"
  /* source === journal_article значит что действие было произведено на странице статьи журнала */
  | "journal_article"
  /* source === book_card значит что действие было произведено на странице крточки арта */
  | "book_card";
